import { Box, Chip, CircularProgress, IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

/**
 * Timeline View actions for a failed fulfillment-center assign / SAP create.
 * Payload and response are loaded on demand via dedicated APIs — same pattern
 * as shipment SAP Order Payload / recording response.
 */
export default function ShipmentCreateFailureStatus({
  hasRequest = false,
  hasResponse = false,
  requestViewLoading = false,
  responseViewLoading = false,
  onRequestViewPayload,
  onRequestViewResponse,
}) {
  if (!hasRequest && !hasResponse) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
        mt: 0.75,
      }}
    >
      {hasRequest ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            size="small"
            label="SAP Order Payload (exact request sent)"
            color="info"
            variant="outlined"
          />
          {onRequestViewPayload ? (
            <IconButton
              size="small"
              aria-label="View exact SAP Order payload sent to the API"
              disabled={requestViewLoading}
              onClick={() => onRequestViewPayload()}
            >
              {requestViewLoading ? (
                <CircularProgress size={16} />
              ) : (
                <VisibilityIcon fontSize="small" />
              )}
            </IconButton>
          ) : null}
        </Box>
      ) : null}
      {hasResponse ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            size="small"
            label="SAP create response"
            color="error"
            variant="outlined"
          />
          {onRequestViewResponse ? (
            <IconButton
              size="small"
              aria-label="View whole SAP create API response"
              disabled={responseViewLoading}
              onClick={() => onRequestViewResponse()}
            >
              {responseViewLoading ? (
                <CircularProgress size={16} />
              ) : (
                <VisibilityIcon fontSize="small" />
              )}
            </IconButton>
          ) : null}
        </Box>
      ) : null}
    </Box>
  )
}
